import { cloneDeep } from "lodash";
import { Template } from "../../common/types/Template";
import {
    allBudgetTypesOptions,
    allDataSourcesOptions,
    allMeasureUnitsOptions,
    allMonthsOptions,
    allMutuallyRedeemingLevelOptions,
    allMutuallyRedeemingOptions,
    allPFOptions,
    allPaymentTypesOptions,
    allPeriodicitiesOptions,
    allReportNamesOptions,
    allReportTypesOptions,
    allSegmentationOptions,
    allStatusOptionsExtended
} from "../../common/baseOptions";
import { ReconPfKfFilterSettings } from "./settings/ReconPfKfFilterSettings";
import { ReconPfKfFilterOptions } from "./options/ReconPfKfFilterOptions";
import { Classificator } from "../../common/types/Classificator";
import { Draggable } from "../../common/types/Draggable";
import { Segmentation } from "../../common/types/roots/fields";

// Разрезности: КБК активна по умолчанию
export const reconPfKfSegmentationOptions: Draggable<Segmentation>[] = [
    { value: 'REGION', label: "Регион", labelKk: "Аймақ", labelEn: "Region", active: false },
    { value: 'KBK', label: "КБК", labelKk: "БСК", labelEn: "KBK", active: true },
    { value: 'GU', label: "ГУ", labelKk: "ММ", labelEn: "DM", active: false }
]

// Расходы
export const reconPfKfExpenseClassificators: Classificator[] = [
    { key: 'gr',  active: true, selected: [] },
    { key: 'pgr', active: true, selected: [] },
    { key: 'abp', active: true, selected: [] },
    { key: 'prg', active: true, selected: [] },
    { key: 'ppr', active: true, selected: [] },
    { key: 'spf', active: true, selected: [] }
]

// Временные настройки для baseTemplate (новый отчёт берёт пустые настройки из getEmptyForm)
const tempSettings: ReconPfKfFilterSettings = {
    reportName: 'RECON-PF-KF',
    reportType: 'REGULATED',
    classificationType: 'EXPENSES',
    dataSource: 'LOADER',
    periodicity: 'DAY',
    date: '',
    year: new Date().getFullYear(),
    month: null,
    region: '',
    budgetTypes: [],
    typePF: 'IPF',
    typePFComponent: 'OBLIGATIONS',
    segmentations: cloneDeep(reconPfKfSegmentationOptions),
    gu: [],
    mutuallyRedeeming: 'WITHOUT',
    mutuallyRedeemingLevels: [],
    statuses: ['39'],
    measureUnit: 'THOUSAND',
    roundUpTo: null,
    onlyDiscrepancies: true,
    onlyLoaded304: true,
    includeEarlierLoaded304: false,
    expenses: cloneDeep(reconPfKfExpenseClassificators)
}

export const reconPfKfBaseTemplate: Template = {
    id: null,
    name: 'Сверка планов финансирования по КФ (по месяцам)',
    excelName: null,
    description: null,
    category: '55',
    regions: [],
    userId: '',
    filterSettings: tempSettings
}

export const reconPfKfFilterOptions: ReconPfKfFilterOptions = {
    // Base:
    key: 'RECON-PF-KF',
    reportNames: cloneDeep(allReportNamesOptions),
    reportTypes: cloneDeep(allReportTypesOptions),
    classificationTypes: [],  // скрыт в форме
    dataSources: cloneDeep(allDataSourcesOptions.filter(it => it.value !== 'MIXED')),
    periodicities: cloneDeep(allPeriodicitiesOptions.filter(it => it.value === 'DAY')),
    // Custom:
    regions: [],
    budgetTypes: cloneDeep(allBudgetTypesOptions),
    // Первый фильтр Вид ПФ — только ИПФ (в будущем добавим СПФ)
    typePFs: cloneDeep(allPFOptions.filter(it => it.value === 'IPF')),
    typePFComponent: cloneDeep(allPaymentTypesOptions),
    segmentations: cloneDeep(reconPfKfSegmentationOptions),
    gu: [],
    mutuallyRedeeming: cloneDeep(allMutuallyRedeemingOptions),
    mutuallyRedeemingLevels: cloneDeep(allMutuallyRedeemingLevelOptions),
    statuses: cloneDeep(allStatusOptionsExtended),
    measureUnits: cloneDeep(allMeasureUnitsOptions),
    months: cloneDeep(allMonthsOptions),
    expenses: cloneDeep(reconPfKfExpenseClassificators)
}
